<script >


import WidgetActionIcon from "@/pages/crm/widgetActionIcon.vue";

export default {
  name: "widgetAction",
  components: { WidgetActionIcon },
  props: {
    action: Object,
    disableReference: {
      type: Boolean,
      default(){return false;}
    }
  },
  methods:{
    goToRef(action){
      switch(action.ref_type){
        case 'offer':
          this.$router.push({name: 'offer', params: {id: action.ref_id}});
          break;
        case 'order':
          this.$router.push({name: 'order', params: {id: action.ref_id}});
          break;
        case 'invoice':
          this.$router.push({name: 'invoice', params: {id: action.ref_id}});
          break;
        default:
          alert(this.$t('actions.unknownReference'));
      }
    },
  }
};

</script>

<template>
  <div class="">
    <div>
      <widget-action-icon :action="action"/>
      <b>{{ action.type.translated }}</b>
      <i v-if="action.ref_type && !disableReference" class="fa-solid fa-square-arrow-right float-end link-primary" @click.stop="goToRef(action)" style="cursor: pointer"></i>
    </div>
    <div class="small row align-items-center" v-if="action.last_subaction">
      <div class="col-auto">
        <i class="fa-solid fa-arrow-turn-down-right text-primary"></i>
      </div>
      <div class="col bg-secondary-subtle p-1 rounded">
        <div><widget-action-icon :action="action.last_subaction"/> <b>{{ action.last_subaction.type.translated }}</b></div>
        <div>{{action.last_subaction.title}}</div>
        <div class="small text-muted d-flex w-100 justify-content-between">
          <span>{{ $filters.date(action.actionDate) }}</span>
          <span v-if="action.creator">{{ action.creator.name }}</span>
        </div>
      </div>
    </div>
    <div class="small" v-else>{{action.title}}</div>
    <div class="small text-muted " v-if="action.reminderDate">
      <span class="text-danger"><i class="fa-solid fa-alarm-clock"></i> {{ $t('actions.reminderAtDate', {date: $filters.date(action.reminderDate)}) }}</span>
    </div>
    <div class="small text-muted d-flex w-100 justify-content-between mt-1">
      <span>{{ $filters.date(action.actionDate) }}</span>
      <span v-if="action.creator">{{ action.creator.name }}</span>
    </div>
  </div>
</template>

<style scoped>

</style>